"use strict";
// Unlocks a profile with its PIN: the server answers with the profile token.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var api_1 = __importDefault(require("stremio/plus/api"));
var ProfileAvatar_1 = __importDefault(require("./ProfileAvatar"));
var PinInput_1 = __importDefault(require("./PinInput"));
var ProfileGate_less_1 = __importDefault(require("./ProfileGate.less"));
var PinPrompt = function (_a) {
    var authKey = _a.authKey, profile = _a.profile, onUnlocked = _a.onUnlocked, onCancel = _a.onCancel, onForgot = _a.onForgot;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(''), pin = _b[0], setPin = _b[1];
    var _c = (0, react_1.useState)(false), invalid = _c[0], setInvalid = _c[1];
    var _d = (0, react_1.useState)(false), checking = _d[0], setChecking = _d[1];
    var _e = (0, react_1.useState)(null), lockedUntil = _e[0], setLockedUntil = _e[1];
    var locked = lockedUntil !== null;
    // The server unlocks on its own; re-enable the input at the same time.
    (0, react_1.useEffect)(function () {
        if (lockedUntil === null)
            return;
        var timeout = setTimeout(function () {
            setLockedUntil(null);
            setInvalid(false);
        }, Math.max(lockedUntil.getTime() - Date.now(), 0));
        return function () { return clearTimeout(timeout); };
    }, [lockedUntil]);
    var onChange = (0, react_1.useCallback)(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPin(value);
                    setInvalid(false);
                    if (value.length !== 4)
                        return [2 /*return*/];
                    setChecking(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, api_1.default.unlock(authKey, profile.id, value)];
                case 2:
                    result = _a.sent();
                    if (result.valid) {
                        onUnlocked({ pin: value, token: result.token, expiresAt: result.expiresAt, needsRecoveryPhrase: result.needsRecoveryPhrase });
                    }
                    else {
                        setInvalid(true);
                        setLockedUntil(result.lockedUntil ? new Date(result.lockedUntil) : null);
                        setPin('');
                    }
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error('Stremio Plus:', e_1);
                    setInvalid(true);
                    return [3 /*break*/, 5];
                case 4:
                    setChecking(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [authKey, profile.id, onUnlocked]);
    return (react_1.default.createElement("div", { className: ProfileGate_less_1.default['picker'] },
        react_1.default.createElement(ProfileAvatar_1.default, { profile: profile }),
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['title'] }, t('PLUS_PROFILES_ENTER_PIN')),
        react_1.default.createElement(PinInput_1.default, { value: pin, onChange: onChange, invalid: invalid, disabled: checking || locked, autoFocus: true }),
        locked && lockedUntil !== null ?
            react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, t('PLUS_PROFILES_PIN_LOCKED', { time: lockedUntil.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }))
            :
                invalid ?
                    react_1.default.createElement("div", { className: ProfileGate_less_1.default['error'] }, t('PLUS_PROFILES_WRONG_PIN'))
                    :
                        null,
        react_1.default.createElement("div", { className: ProfileGate_less_1.default['actions'] },
            react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['button'], onClick: onCancel }, t('PLUS_PROFILES_CANCEL')),
            onForgot ?
                react_1.default.createElement(components_1.Button, { className: ProfileGate_less_1.default['link-button'], onClick: onForgot }, t('PLUS_PROFILES_FORGOT_PIN'))
                :
                    null)));
};
exports.default = PinPrompt;
